var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22Z",
    fill: "#FF3F72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z",
    fill: "#FF3F72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34302 19.6572C7.44759 19.6572 8.34302 18.7618 8.34302 17.6572C8.34302 16.5527 7.44759 15.6572 6.34302 15.6572C5.23845 15.6572 4.34302 16.5527 4.34302 17.6572C4.34302 18.7618 5.23845 19.6572 6.34302 19.6572Z",
    fill: "#FF3F72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 14.001C5.10514 14.001 6.00102 13.1051 6.00102 12C6.00102 10.8949 5.10514 9.99902 4.00002 9.99902C2.8949 9.99902 1.99902 10.8949 1.99902 12C1.99902 13.1051 2.8949 14.001 4.00002 14.001Z",
    fill: "#FF3F72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z",
    fill: "#FF3F72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34302 8.34375C7.44759 8.34375 8.34302 7.44832 8.34302 6.34375C8.34302 5.23918 7.44759 4.34375 6.34302 4.34375C5.23845 4.34375 4.34302 5.23918 4.34302 6.34375C4.34302 7.44832 5.23845 8.34375 6.34302 8.34375Z",
    fill: "#FF3F72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.657 19.6582C18.7616 19.6582 19.657 18.7628 19.657 17.6582C19.657 16.5536 18.7616 15.6582 17.657 15.6582C16.5524 15.6582 15.657 16.5536 15.657 17.6582C15.657 18.7628 16.5524 19.6582 17.657 19.6582Z",
    fill: "#FF3F72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.0b715678856ca1c02c650bed3a6e2065.svg";
export { ForwardRef as ReactComponent };